import React from 'react';
import { BrandMark } from '../BrandMark';
interface EmptyStateProps {
  title: string;
  body: string;
  action?: React.ReactNode;
}
export function EmptyState({
  title,
  body,
  action
}: EmptyStateProps) {
  return <div className="flex flex-col items-center gap-2 rounded-card border border-dashed border-sand-line bg-white/50 px-3 py-6 text-center" data-id="element-1494" data-mp="1oe1k687w2nl7">
      <BrandMark size={40} className="opacity-35" data-id="element-1495" data-mp="1schdetukcs72" />
      <h2 className="text-title text-deep" data-id="element-1496" data-mp="vp45ef2vz8x7">{title}</h2>
      <p className="max-w-[30ch] text-[13px] leading-relaxed text-muted" data-id="element-1497" data-mp="vmhx2d868pdx">{body}</p>
      {action}
    </div>;
}